var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurkmenistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M16.747 4.61a2.452 2.452 0 00-.997-2.888c.174.026.345.069.51.128a2.436 2.436 0 11-1.65 4.582 2.305 2.305 0 01-.473-.232 2.438 2.438 0 002.61-1.59zm-2.19-3.188l-.337.443-.525-.188.315.465-.345.443.54-.158.315.458.015-.555.533-.158-.525-.187.014-.563z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M15.488 2.863l-.345.442-.526-.187.315.465-.345.442.54-.157.316.457.014-.555.533-.157-.525-.188.023-.562zm-2.558-.915l-.338.442-.524-.187.315.465-.345.442.54-.157.307.457.023-.555.532-.157-.525-.188.015-.562zm-.037 1.65l-.338.442-.525-.187.315.465L12 4.76l.533-.157.322.457.015-.555.533-.157-.526-.188.015-.562zm1.574.562l-.345.443-.524-.188.314.465-.345.443.54-.158.316.458.014-.555.533-.158-.525-.187.022-.563z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M8.093-.003H3.915v15.998h4.178V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M5.505 4.213l-.698-.518v-.742l.698-.518h.99l.697.518v.742l-.697.518h-.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M6 2.435h-.495l-.698.518v.36H6v-.878zm0 1.778h.495l.697-.518v-.382H6v.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M5.505 13.565l-.698-.518v-.735l.698-.524h.99l.697.524v.736l-.697.517h-.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M6 11.787h-.495l-.698.525v.36H6v-.885zm0 1.778h.495l.697-.518v-.375H6v.893z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M5.505 8.885l-.698-.518v-.735l.698-.525h.99l.697.525v.735l-.697.518h-.99zm1.71 1.148h-.3v-.3h-.54L6 9.35l-.375.382h-.54v.3h-.3v.608h.3v.307h.54l.375.376.375-.376h.54v-.307h.3v-.607zm0-4.673h-.3v-.308h-.54L6 4.677l-.375.375h-.54v.308h-.3v.607h.3v.3h.54L6 6.65l.375-.383h.54v-.3h.3V5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.353 7.655h-.698v.697h.698v-.697zM6 6.005a.345.345 0 100-.69.345.345 0 000 .69zm0 4.68a.345.345 0 100-.69.345.345 0 000 .69z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkmenistan);
export default __webpack_public_path__ + "static/media/Turkmenistan.a8f5f5a299e14f9efdf80eeb36cff818.svg";
export { ForwardRef as ReactComponent };